// extracted by mini-css-extract-plugin
export default {"header":"w0mGPsgc","linkInputGroup":"JaW3hli9","copyStatus":"f6j1pPKU","shareHeading":"z7HCsgzD","buttonContainer":"pELsE2ID","qrCode":"zlV_G12k"};